import { render, staticRenderFns } from "./TherapistDashExpendituresList.vue?vue&type=template&id=5fffad04&scoped=true"
import script from "./TherapistDashExpendituresList.vue?vue&type=script&lang=js"
export * from "./TherapistDashExpendituresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fffad04",
  null
  
)

export default component.exports